import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../auth/services/auth.service';
import { OtpModel } from '../../../auth/models/otp.model';
import { FormsModule } from '@angular/forms';

@Component({
  imports:[FormsModule],
  selector: 'app-otp',
  templateUrl: './otp.component.html'
})
export class OtpComponent {

  model: OtpModel = {
    userId: '',
    otpCode: ''
  };

  constructor(
    private route: ActivatedRoute,
    private auth: AuthService,
    private router: Router
  ) {}

  ngOnInit(){
    this.model.userId = this.route.snapshot.queryParamMap.get("userId")!;
  }

  verify(){

    // this.auth.verifyOtp(this.model)
    //   .subscribe(res => {

    //     if(res.success){
    //       this.auth.saveToken(res.accessToken!);
    //       this.router.navigate(['/app']);
    //     }

    //   });

  }

}